import * as React from 'react';

import styles from './annual-savings-pill.module.css';

type Props = {
    savings: string;
};

export function AnnualSavingsPill(props: Props) {
    return <div className={styles.container}>Paid Annually | Saves {props.savings}</div>;
}
